export const fmtInt = n =>
  n == null || !Number.isFinite(n) ? '--' : Math.round(n).toLocaleString('en-US');

export function fmtCompact(n) {
  if (n == null || !Number.isFinite(n)) return '--';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}M`;
  if (abs >= 10_000) return `${(n / 1000).toFixed(0)}K`;
  if (abs >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return Math.round(n).toLocaleString('en-US');
}

export function fmtUsd(n, { compact = false } = {}) {
  if (n == null || !Number.isFinite(n)) return '--';
  if (compact) {
    const abs = Math.abs(n);
    if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(abs >= 10_000_000 ? 0 : 1)}M`;
    if (abs >= 10_000) return `$${(n / 1000).toFixed(0)}K`;
    if (abs >= 1000) return `$${(n / 1000).toFixed(1)}K`;
  }
  return `$${Math.round(n).toLocaleString('en-US')}`;
}

export function fmtPct(n, places = 1) {
  if (n == null || !Number.isFinite(n)) return '--';
  return `${(n * 100).toFixed(places)}%`;
}

export function fmtDays(n) {
  if (n == null || !Number.isFinite(n)) return '--';
  if (n < 1) return 'same day';
  if (n < 60) return `${Math.round(n)} days`;
  const months = n / 30.44;
  if (months < 24) return `${months.toFixed(months < 10 ? 1 : 0)} mo`;
  return `${(n / 365.25).toFixed(1)} yr`;
}

export function fmtDate(iso, { withTime = false } = {}) {
  if (!iso) return '--';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '--';
  const opts = withTime
    ? { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }
    : { year: 'numeric', month: 'short', day: 'numeric' };
  return d.toLocaleDateString('en-US', opts);
}

/** Axis ticks rounded to human numbers. */
export function niceTicks(max, count = 4) {
  if (!Number.isFinite(max) || max <= 0) return [0];
  const raw = max / count;
  const mag = 10 ** Math.floor(Math.log10(raw));
  const norm = raw / mag;
  const step = (norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 2.5 ? 2.5 : norm <= 5 ? 5 : 10) * mag;
  // Always run past `max` so the top tick can carry the tallest mark.
  const ticks = [];
  for (let v = 0; ; v += step) {
    ticks.push(Math.round(v * 1e6) / 1e6);
    if (v >= max - step * 1e-9) break;
  }
  return ticks;
}
